module.exports = __webpack_public_path__ + "static/img/creative.bd74a7e9.png";